import api from './api';

export const adService = {
  getAll: async () => {
    const res = await api.get('/Ad/GetAll');
    return res.data.data;
  },

  getActive: async () => {
    const res = await api.get('/Ad/GetActive');
    return res.data.data;
  },

  getById: async (id) => {
    const res = await api.get(`/Ad/GetById/${id}`);
    return res.data.data;
  },

  create: async (payload) => {
    const res = await api.post('/Ad/Create', payload);
    return res.data.data;
  },

  update: async (id, payload) => {
    const res = await api.put(`/Ad/Update/${id}`, payload);
    return res.data.data;
  },

  delete: async (id) => {
    const res = await api.delete(`/Ad/Delete/${id}`);
    return res.data.data;
  },

  toggleActive: async (id) => {
    const res = await api.patch(`/Ad/ToggleActive/${id}`);
    return res.data.data;
  },
};
